import styled, { css } from "styled-components";
import { theme } from "theme/theme";

export const FiltersContainer = styled.div`
  position: absolute;
  top: 36px;
  left: 100px;
  padding: 20px;
  background-color: ${theme.colors.white};
  border: solid 1px ${theme.colors.borderColorLight};
  border-radius: 8px;
  box-shadow: ${theme.boxShadow};
  width: 400px;
  z-index: 3;
  max-height: calc(100vh - 80px);
  overflow: auto;
`;

export const ScrollContainer = styled.div`
  max-height: calc(100vh - 200px);
  min-height: 400px;
  overflow-x: auto;
  margin-bottom: 20px;
`;

export const SectionHeader = styled.div`
  font-size: 14px;
  line-height: 21px;
  font-weight: 700;
  border-bottom: solid 1px ${theme.colors.borderColorDark};
  padding: 4px 0;
`;

export const SectionContent = styled.div<{ maxHeight?: number }>`
  padding: 10px 0;

  ${props => props.maxHeight && css`
    position: relative;
    max-height: ${props.maxHeight}px;
    overflow-x: auto;
  `}
`;

export const StyledNumberCompare = styled.div`
  display: flex;
  gap: 10px;

  .react-dropdown-select-content {
    span {
      width: 100%;
      text-align: center;
    }
    
    .react-dropdown-select-input {
      width: 0;
      margin-left: 0;
    }
  }

  .react-dropdown-select-item {
    text-align: center;
    padding: 10px;
  }
`;

export const StyledNoOptions = styled.div`
  padding: 4px 0 10px 10px;
  color: ${theme.colors.textDisabled};
  font-size: 14px;
`;
